"use strict";
import { urls } from "../constants";

export default {
  mainPage: {
    0: [
      {
        image: "/images/main_fastfoot.JPG",
        link: "/fastfoot/overview",
        title: "FASTFOOT",
        subLinks: {
          overview: {
            link: "/fastfoot/overview",
            title: "Overview",
            description: "Description",
          },
          installation: {
            link: "/fastfoot/installation",
            title: "Installation",
            description: "Description",
          },
          projects: {
            link: "/fastfoot/projects",
            title: "Projects",
            description: "Description",
          },
        },
        description: "This is a project from...",
      },
      {
        image: "/images/main-fast-tube.jpg",
        link: "/fast-tube/overview",
        title: "FAST-TUBE",
        description: "Title 2",
        subLinks: {
          overview: {
            link: "/fast-tube/overview",
            title: "Overview",
            description: "Description",
          },
          installation: {
            link: "/fast-tube/installation",
            title: "Installation",
            description: "Description",
          },
          projects: {
            link: urls.fastTube.projects,
            title: "Projects",
            description: "Description",
          },
        },
      },
      {
        image: "/images/main-zont-bracing.JPG",
        link: "/zont-bracing/overview",
        title: "ZONT BRACING",
        description: "Title 3",
        subLinks: {
          overview: {
            link: urls.zontBracing.overview,
            title: "Overview",
            description: "Description",
          },
          installation: {
            link: urls.zontBracing.installation,
            title: "Installation",
            description: "Description",
          },
          projects: {
            link: "/zont-bracing/projects",
            title: "Projects",
            description: "Description",
          },
        },
      },
    ],
  },
  testimonials: {
    0: [
      {
        text: "Fab-Form believes strongly in the public company structure as it enables our employees to become owners. And it enables the public to participate in our growth from exceptional innovative products that assist in taming the ground interface",
        person: "Rick Fearn",
      },
      {
        text: "Fab-Form believes strongly in the public company structure as it enables our employees to become owners. And it enables the public to participate in our growth from exceptional innovative products that assist in taming the ground interface",
        person: "Rick Fearn",
      },
      {
        text: "Fab-Form believes strongly in the public company structure as it enables our employees to become owners. And it enables the public to participate in our growth from exceptional innovative products that assist in taming the ground interface",
        person: "Rick Fearn",
      },
      {
        text: "Fab-Form believes strongly in the public company structure as it enables our employees to become owners. And it enables the public to participate in our growth from exceptional innovative products that assist in taming the ground interface",
        person: "Rick Fearn",
      },
      {
        text: "Fab-Form believes strongly in the public company structure as it enables our employees to become owners. And it enables the public to participate in our growth from exceptional innovative products that assist in taming the ground interface",
        person: "Rick Fearn",
      },
      {
        text: "Fab-Form believes strongly in the public company structure as it enables our employees to become owners. And it enables the public to participate in our growth from exceptional innovative products that assist in taming the ground interface",
        person: "Rick Fearn",
      },
      {
        text: "Fab-Form believes strongly in the public company structure as it enables our employees to become owners. And it enables the public to participate in our growth from exceptional innovative products that assist in taming the ground interface",
        person: "Rick Fearn",
      },
      {
        text: "Fab-Form believes strongly in the public company structure as it enables our employees to become owners. And it enables the public to participate in our growth from exceptional innovative products that assist in taming the ground interface",
        person: "Rick Fearn",
      },
      {
        text: "Fab-Form believes strongly in the public company structure as it enables our employees to become owners. And it enables the public to participate in our growth from exceptional innovative products that assist in taming the ground interface",
        person: "Rick Fearn",
      },
      {
        text: "Fab-Form believes strongly in the public company structure as it enables our employees to become owners. And it enables the public to participate in our growth from exceptional innovative products that assist in taming the ground interface",
        person: "Rick Fearn",
      },
    ],
  },
  robertBiersteker: {
    1: [
      {
        image: "/images/projects/concrete4.webp",
        description:
          "Fab-Form Monopour works perfectly with stem walls. This foundation is for a Viceroy Home in Langley, BC",
      },
      {
        image: "/images/projects/c2.webp",
        description:
          'Note the 4 - 6" drainage layer which allows any site water ready access to perimeter drain system',
      },
      {
        image: "/images/projects/c3.webp",
        description: "Installation of components took approximately two hours",
      },
      {
        image: "/images/projects/c4.webp",
        description:
          "The connection between the interior and exterior footings is easy with Fastfoot®: interior footings will be monopoured with the slab later",
      },
      {
        image: "/images/projects/b1.webp",
        description:
          "Zont™ bracing is ideal for stem walls: Zont™ brackets have been attached and walers and strongbacks installed, ready for final alignment",
      },
      {
        image: "/images/projects/b2.webp",
        description:
          "The base of each strongback is placed in exact position, then staked to ground",
      },
      {
        image: "/images/projects/b3.webp",
        description:
          "Angle braces are staked in position and adjusted to plumb the wall perfectly",
      },
      {
        image: "/images/projects/b4.webp",
        description: "The foundation is completely aligned, ready for concrete",
      },
      {
        image: "/images/projects/concrete1.webp",
        description:
          "Sewn Fastfoot® corners prevent all ground moisture from wicking in bottom, sides and top of footing",
      },
      {
        image: "/images/projects/concrete2.webp",
        description:
          "The protruding rebar will interconnect with the rebar in the monolithically poured footing/slab in the crawl space",
      },
      {
        image: "/images/projects/dimple-membrane.webp",
        description:
          "Dimple membrane on ICF is lapped over Fastfoot®, ensuring all ground moisture bypasses foundation",
      },
    ],
  },
  testimonialNewsRelease: {
    0: [
      {
        image: "/images/projects/hs2.webp",
        description: "Scribing the foundation components to the rock",
      },
      {
        image: "/images/projects/hs3.webp",
        description: "Components ready for installation",
      },
      {
        image: "/images/projects/hs1.webp",
        description: "Components installed around perimeter",
      },
      {
        image: "/images/projects/hs4.webp",
        description: "Components have been leveled up with drill",
      },
      {
        image: "/images/projects/hs5.webp",
        description: "Fastfoot® is buttoned up to the bottom of the block",
      },
      {
        image: "/images/projects/hs6.webp",
        description: "A 4'step is easily handled with the MP System",
      },
      {
        image: "/images/projects/hs7.webp",
        description: "Walls braced, concrete is poured",
      },
      {
        image: "/images/projects/hs8.webp",
        description: "Building up the main floor walls with BuildBlock®",
      },
      {
        image: "/images/projects/hs9.webp",
        description: "Installing the roof trusses",
      },
      {
        image: "/images/projects/hs10.webp",
        description: "Installing siding, project almost complete",
      },
    ],
    1: [
      {
        image: "/images/projects/aw1.webp",
        description: "Building site ready for installation of Fastfoot® MP",
      },
      {
        image: "/images/projects/aw2.webp",
        description: "Cutting custom components, easy with BuildBlock®",
      },
      {
        image: "/images/projects/aw3.webp",
        description: "Gluing foundation components",
      },
      {
        image: "/images/projects/aw4.webp",
        description: "Installing foundation components",
      },
      {
        image: "/images/projects/aw5.webp",
        description: "Installing interior bracing",
      },
      {
        image: "/images/projects/aw6.webp",
        description: "Fastfoot® buttoned up to base of foundation wall",
      },
      {
        image: "/images/projects/aw7.webp",
        description: "Filling the footing bag",
      },
      {
        image: "/images/projects/aw8.webp",
        description: "Filling the footing and foundation wall",
      },
      {
        image: "/images/projects/aw10.webp",
        description: "Pouring concrete",
      },
      {
        image: "/images/projects/aw9.webp",
        description: "Pour complete, removing bracing",
      },
    ],
    2: [
      {
        image: "/images/projects/robro2.webp",
        description:
          "Conventional ICF bracing was used with small kickers on outside",
      },
      {
        image: "/images/projects/robro3.webp",
        description: "Top of the wall was protected from heat loss with tarps",
      },
      {
        image: "/images/projects/robro4.webp",
        description:
          "A small electric heater located inside the footing fabric prevented the ground from freezing",
      },
      {
        image: "/images/projects/robro5.webp",
        description:
          "The Monopour was a success. We saved a day or two by doing the pour this way",
      },
    ],
    3: [
      {
        image: "/images/projects/ra1.webp",
        description:
          "Foundation components installed, ready for balance of wall",
      },
      {
        image: "/images/projects/ra2.webp",
        description: "Nudura® block installation continues",
      },
      {
        image: "/images/projects/ra3.webp",
        description: "Bracing begins, using horizontal bracing",
      },
      {
        image: "/images/projects/ra4.webp",
        description: "Zont bracing is used on the inside of the foundation",
      },
      {
        image: "/images/projects/ra8.webp",
        description: "Watching Fastfoot® fill with concrete",
      },
      {
        image: "/images/projects/ra5.webp",
        description: "The perfect footing, protecting against ground moisture",
      },
      {
        image: "/images/projects/ra6.webp",
        description:
          "Fastfoot® protects moisture entry on the bottom, sides and top",
      },
      {
        image: "/images/projects/ra7.webp",
        description: "Final bracing of wall during the concrete pour",
      },
      {
        image: "/images/projects/ra9.webp",
        description: "Foundation pour complete, perfect alignment",
      },
    ],
    4: [
      {
        image: "/images/projects/cp3-1.webp",
        description:
          "Arxx® blocks were pre-glued into components, with Zont bracing pre-installed",
      },
      {
        image: "/images/projects/cp2-1.webp",
        description:
          "The forklift was used to lift components onto the trailer",
      },
      {
        image: "/images/projects/cp4-1.webp",
        description:
          "Premanufactured components delivered to jobsite, with side supports pre-installed",
      },
      {
        image: "/images/projects/cp1-1.webp",
        description: "Fastfoot® was laid out in the excavation",
      },
      {
        image: "/images/projects/cp5-1.webp",
        description:
          "Components are dropped into the excavation and leveled up",
      },
      {
        image: "/images/projects/cp6-1.webp",
        description: "The foundation is level and plumb, ready for concrete",
      },
    ],
    5: [
      {
        image: "/images/projects/bg1.webp",
        description: "Completed pour, walls level and plumb",
      },
      {
        image: "/images/projects/bg2.webp",
        description: "Completed pour, walls level and plumb",
      },
      {
        image: "/images/projects/bg3.webp",
        description: "Completed pour, walls level and plumb",
      },
    ],
  },
  preAttachedFastfoot: {
    0: [
      {
        image: "/images/projects/outside-corner-after.webp",
        description: "A sewn Fastfoot® corner creates the perfect footing",
      },
      {
        image: "/images/projects/ci1.webp",
        description: "Fastfoot® is pre-attached to a standard 12' component",
      },
      {
        image: "/images/projects/ci3.webp",
        description: "Installing a custom component with pre-attached fabric",
      },
      {
        image: "/images/projects/ci8.webp",
        description:
          "Ready to install two straight components with pre-attached fabric",
      },
      {
        image: "/images/projects/ci4.webp",
        description:
          "All lower level components with pre-attached Fastfoot® are now installed",
      },
      {
        image: "/images/projects/inside-corner-before.webp",
        description: "Sewn corner before concrete",
      },
      {
        image: "/images/projects/inside-corner-filling.webp",
        description: "Sewn corner being filled with concrete",
      },
      {
        image: "/images/projects/outside-corner-after.webp",
        description: "Sewn corner, after concrete",
      },
      {
        image: "/images/projects/perfect-footing.webp",
        description:
          "Fastfoot® protects the bottom, sides and top of footing from ground moisture",
      },
      {
        image: "/images/projects/poured-foundation.webp",
        description:
          "Pouring the foundation with presewn and pre-attached fabric",
      },
    ],
  },
  howeSoundIsland: {
    5: [
      {
        image: "/images/projects/loading-barge.webp",
        description:
          "The 80' x 32' barge was loaded high with construction materials in Horseshoe Bay, West Vancouver for delivery to the Howe Sound Island",
      },
      {
        image: "/images/projects/jamieson-components.webp",
        description:
          "Jamieson ready to install the pre-manufactured foundation components Wednesday morning",
      },
      {
        image: "/images/projects/setting-up-components.webp",
        description:
          "The Fab-Form components interlock into position around the perimeter with the footing fabric pre-installed",
      },
      {
        image: "/images/projects/main-foundation-complete.webp",
        description: "Wednesday evening: main foundation installed and braced",
      },
      {
        image: "/images/projects/concrete-truck-barge.webp",
        description:
          "Friday morning: the three concrete trucks and boom pump ready for action. Now who was complaining about the weather?",
      },
      {
        image: "/images/projects/pouring-main-foundation.webp",
        description:
          "Jim of Sutherland Concrete pours the main cottage foundation Friday morning",
      },
      {
        image: "/images/projects/pouring-bunk-house.webp",
        description:
          "Pouring the bunk house: the sequence was footings first, then stem wall, then skim coat",
      },
      {
        image: "/images/projects/zont-cam-lock.webp",
        description:
          "The ICF wall alignment was with the new Zont CamLock which twist tightens on the strongback and waler",
      },
    ],
  },
  econUbc: {
    1: [
      {
        image: "/images/projects/arranging-components.webp",
        description:
          "Pre-manufactured ICF components with pre-installed Fastfoot® are set up around the perimeter",
      },
      {
        image: "/images/projects/stringlines.webp",
        description:
          "Stringlines are used to align the manufactured foundation components",
      },
      {
        image: "/images/projects/zont-bracing.webp",
        description:
          "Zont™ horizontal bracing flattens the ICF foundation wall perfectly",
      },
      {
        image: "/images/projects/bracing-installed.webp",
        description:
          "The bracing and scaffolding is almost complete. Note the use of Fastfoot® on interior footings",
      },
      {
        image: "/images/projects/concrete-pour-complete.webp",
        description: "Another perfect pour by the Econ Group",
      },
      {
        image: "/images/projects/concrete-pour-complete2.webp",
        description:
          "Note the use of a drainage layer to ensure water is kept away from the footings",
      },
      {
        image: "/images/projects/concrete-pour-complete3.webp",
        description:
          "Concrete pour is complete, ready to instal the anchor bolts",
      },
      {
        image: "/images/projects/fastfoot.webp",
        description:
          "Fastfoot® is ideal for the interior footings as the membrane prevents ground moisture wicking up into the home",
      },
      {
        image: "/images/projects/backfill-complete.webp",
        description:
          "Interior slab has been poured, basement interior walls complete, ready for floor panels",
      },
      {
        image: "/images/projects/panels-on-truck.webp",
        description: "Floor, wall and roof panels were delivered by flat deck",
      },
      {
        image: "/images/projects/panels-complete.webp",
        description: "The Fab-Form Monopour is ideal for panelized housing",
      },
    ],
  },
  usar: {
    1: [
      {
        image: "/images/projects/bracing.webp",
        description: "Plumbing the corner using Zont™ bracing system",
      },
      {
        image: "/images/projects/level1.webp",
        description:
          "Level one components were installed in two hours by positioning against the string lines and levelling up",
      },
      {
        image: "/images/projects/level2.webp",
        description:
          "Second level component were installed. Then two levels of Zonts™ screw attached around the perimeter 6' on center",
      },
      {
        image: "/images/projects/install-steel.webp",
        description:
          "Reinforcing steel is preinstalled in the footings and corners. The remaining steel installed on site",
      },
      {
        image: "/images/projects/ready-for-bucks.webp",
        description:
          "Openings are ready to have the pre-manufactured window bucks installed",
      },
      {
        image: "/images/projects/placing-concrete.webp",
        description:
          'Concrete supplied was a 5 to 6 inch slump, aggregate size 3/8" and under',
      },
      {
        image: "/images/projects/filling-footing.webp",
        description:
          "The footing was filled first, then allowed to go off, before filling wall",
      },
      {
        image: "/images/projects/perfect-alignment.webp",
        description:
          'Top of wall accuracy of 1/8" is easily achieved with the height adjustable monopour supports and Zont™ bracing',
      },
    ],
  },
  ecoHeritage: {
    3: [
      {
        image: "/images/projects/sc1.webp",
        description:
          "The new foundations were located within 12\" of the property lines on each side. Pilings were driven into the ground 5' on centre to support neighbour's soil",
      },
      {
        image: "/images/projects/sc2.webp",
        description:
          "The excavator digs out sections three pilings wide (about 10' wide) to enable the installation of the wire mesh prior to shotcreting",
      },
      {
        image: "/images/projects/sc3.webp",
        description:
          "The wire mesh is installed around three pilings so that the ground behind is adequately supported",
      },
      {
        image: "/images/projects/sc4.webp",
        description:
          "The shot crete is applied to the wire mesh in the 10' excavated sections",
      },
      {
        image: "/images/projects/sc5.webp",
        description:
          "The excavator removed the soil between the shot screeded sections and wire mesh was applied",
      },
      {
        image: "/images/projects/sc6.webp",
        description:
          "Stucco is applied to the remaining sections to support the neighbour's ground and foundations",
      },
      {
        image: "/images/projects/sc7.webp",
        description:
          "The completed excavation looking south showing the two heritage buildings temporily moved to the south end of the property",
      },
      {
        image: "/images/projects/sc8.webp",
        description:
          "This view of the completed excavation looking north. Note the height difference of 4' between the two foundations. Also note the 4\" drainage layer to prevent rising damp",
      },
    ],
    4: [
      {
        image: "/images/projects/icfa1.webp",
        description:
          "The west wall of the west foundation is located inches from the shotcrete and inches from the cribbing. Note the Fastfoot® footing",
      },
      {
        image: "/images/projects/icfa2.webp",
        description:
          "This east wall (10' tall) of the west building is located next to the 4' elevation change. Note the Zont™ bracing in position to hold the wall flat",
      },
      {
        image: "/images/projects/icfa3.webp",
        description:
          "The cribbing was done by Nickle Brothers. Note the method used to support the east building 4' higher so that the cribbing did not hit the interior footings",
      },
      {
        image: "/images/projects/icfa4.webp",
        description:
          "Note how effective the Zont™ (horiZONTal) Bracing System is in producing a flat and plumb wall",
      },
      {
        image: "/images/projects/icfa5.webp",
        description:
          "This view from the south of the west foundation also shows an underground utility room for all of the seven units",
      },
      {
        image: "/images/projects/icfa6.webp",
        description:
          "A delicate balancing act: the two heritage buildings supported by the cribbing and steel beams",
      },
      {
        image: "/images/projects/icfb1.webp",
        description:
          'The foundation for the east building was 30" narrower than the heritage structure above, so enable a public walkway between the two buildings',
      },
      {
        image: "/images/projects/icfb2.webp",
        description:
          "The foundation is manufactured in components 13'-4\" long with the Fastfoot® and steel pre-installed. Fab-Form employee Ljuba buttons up the Fastfoot® overlaps",
      },
      {
        image: "/images/projects/icfb3.webp",
        description:
          "A 4' step at the end of this foundation was required to accomodate the underground utility room. Fastfoot® forms this step without a single piece of lumber",
      },
    ],
    5: [
      {
        image: "/images/projects/cp1.webp",
        description:
          "Note the formwork congestion. An interior footing can be seen squeezed between the east foundation wall and cribbing",
      },
      {
        image: "/images/projects/cp2.webp",
        description:
          "Note the multiplicity of formwork: ICF wall forms, fabric footing forms, architectural plywood wall forms for the suite entrance on the right and plywood stem wall forms",
      },
      {
        image: "/images/projects/cp3.webp",
        description:
          "The Fastfoot® monopour system was perfect for this congested site where the ICF wall form was located just inches from the shotcreted excavation wall and cribbing",
      },
      {
        image: "/images/projects/cp4.webp",
        description:
          "A 2' ICF return forms the south end of the west building. An outside patio is located between the stem wall and the retaining wall located in the distance",
      },
      {
        image: "/images/projects/cp5.webp",
        description:
          'Zuckle™ wall aligners were supported from the floor structure. Only 16" of space between the floor joists and top of wall made placing concrete a challenge',
      },
      {
        image: "/images/projects/cp6.webp",
        description:
          "The space between the two foundations will become a walkway to the common area between the two heritage houses and the laneway house in the rear",
      },
      {
        image: "/images/projects/cp7.webp",
        description:
          "This 4' step was poured without a single piece of lumber, hence no waste. Compare this with plywood formed steps",
      },
      {
        image: "/images/projects/cp8.webp",
        description:
          "Premanufactured door and window bucks were set into the ICF foundation components to reduce construction time",
      },
      {
        image: "/images/projects/cp9.webp",
        description:
          "Stringlines were used to accurately align the wall both before and after the pour",
      },
      {
        image: "/images/projects/cp10.webp",
        description:
          "The south end of this foundation dropped off 4' to allow the below grade utility room for the seven units",
      },
      {
        image: "/images/projects/cp11.webp",
        description:
          "As there was insufficient space for a drainage pipe on the outside of the footing, the building envelope engineer required 2\" pipes under the footing, 8' on centre",
      },
    ],
  },
  modHome: {
    0: [
      {
        image: "/images/projects/e1.webp",
        description:
          "Ready to begin the excavation with John Hoar, Dan McGoey, red seal carpenters, and Steven Thomson, P Eng, Project Manager, on right",
      },
      {
        image: "/images/projects/e2.webp",
        description:
          "This project is located just north of Yellowknife, with a view of Great Slave Lake, the ninth largest lake in North America, 480 km long and 109 km wide",
      },
      {
        image: "/images/projects/e3.webp",
        description:
          "Typical ground conditions around Yellowknife: solid granite with minimal overburden and northern vegetation",
      },
      {
        image: "/images/projects/e4.webp",
        description:
          "Project lot looking west, note granite protruding on the far side with crushed rock overburden on much of the site",
      },
      {
        image: "/images/projects/e5.webp",
        description:
          "Project lot looking east, with crushed rock overburden between the granite protrusion and road",
      },
      {
        image: "/images/projects/e6.webp",
        description:
          "Backhoe operator begins to clear the overburden off the exposed rock",
      },
      {
        image: "/images/projects/e7.webp",
        description:
          "Special teeth in the bucket are designed to minimize wear with the hard granite",
      },
      {
        image: "/images/projects/e8.webp",
        description:
          "Utility lines must be buried deep with insulation above to prevent freezing during the long and cold winters",
      },
      {
        image: "/images/projects/e9.webp",
        description:
          "Contractor drills and epoxies rebar into the exposed granite",
      },
      {
        image: "/images/projects/e10.webp",
        description:
          "Contractor spreads gravel over footing area in preparation for the monopour formwork",
      },
      {
        image: "/images/projects/e11.webp",
        description:
          "Gravel is compacted with a plate tamper, ready for the monopour system",
      },
    ],
    1: [
      {
        image: "/images/projects/m8.webp",
        description:
          "Perfect pour. Note the contracto pre-installed blueskin before the pour to provide moisture protection in the rear where the rock dipped down",
      },
      {
        image: "/images/projects/m1.webp",
        description:
          "Setting up the monopour components across the front of the two duplexes",
      },
      {
        image: "/images/projects/m2.webp",
        description:
          "View from the interior - a partition between the two units will be set up later",
      },
      {
        image: "/images/projects/m3.webp",
        description:
          "The contractor is beginning to scribe the blocks to accomodate the rock outcrop at the rear",
      },
      {
        image: "/images/projects/m4.webp",
        description:
          "Accomodating the rock outcrop by cutting the base of the blocks",
      },
      {
        image: "/images/projects/m5.webp",
        description:
          "Accomodating the rock outcrop by cutting the base of the blocks",
      },
      {
        image: "/images/projects/m6.webp",
        description:
          "Accomodating the rock outcrop by cutting the base of the blocks",
      },
      {
        image: "/images/projects/m7.webp",
        description:
          "Ready for concrete, ready mix concrete in Yellowknife is $210 a cubic yard",
      },
      {
        image: "/images/projects/m10.webp",
        description:
          "Spray foam was used to fill in the gap between the bottom of the block and the rock face",
      },
      {
        image: "/images/projects/m9.jpg",
        description:
          "String lines and Zuckle wall aligners were used to obtain perfect alignment of the top of wall",
      },
    ],
    2: [
      {
        image: "/images/projects/cm1.webp",
        description:
          "Completed duplex. Modhome Developments achieved an Energuide rating of 82, the highest ever achieved in Yellowknife",
      },
      {
        image: "/images/projects/cm2.webp",
        description:
          "Foundation is complete, awaiting the arrival of the modular units",
      },
      {
        image: "/images/projects/cm3.webp",
        description:
          "View of the completed foundation from the rear of the building lot",
      },
      {
        image: "/images/projects/cm4.webp",
        description:
          "One of the four modular units being constructed in the factory in Edmonton",
      },
      {
        image: "/images/projects/cm5.webp",
        description: "The fourth modular unit is craned into position",
      },
      {
        image: "/images/projects/cm8.webp",
        description:
          "The four units have been craned into position, finishing between the units is to be completed",
      },
      {
        image: "/images/projects/cm6.webp",
        description:
          "Front porch detailing is modern, attractive and ideal for winter conditons",
      },
      {
        image: "/images/projects/cm7.webp",
        description:
          "Interior view of the second floor, showing the kitchen and living areas",
      },
      {
        image: "/images/projects/cm9.webp",
        description: "Bedroom and bathroom located on the first floor",
      },
    ],
  },
  tomsBackhoe: {
    0: [
      {
        image: "/images/projects/toms-backhoe-1.webp",
        description: "Finishing the slab edge formed with Fastfoot®.",
      },
      {
        image: "/images/projects/toms-backhoe-2.webp",
        description:
          "2x6 screed boards were installed around the perimeter using metal stakes",
      },
      {
        image: "/images/projects/toms-backhoe-3.webp",
        description:
          "Footing area was dug out to the correct depth using the edge forms as the reference",
      },
      {
        image: "/images/projects/toms-backhoe-4.webp",
        description:
          "Plumbing and electrical utities were installed using the edge forms as the reference point",
      },
      {
        image: "/images/projects/toms-backhoe-5.webp",
        description:
          "Fabric was attached to screed board using a hammer tacker with 3/8&quote; staples",
      },
      {
        image: "/images/projects/toms-backhoe-6.webp",
        description:
          "4&quote; wire mesh was used to reinforce the slab and prevent cracking",
      },
      {
        image: "/images/projects/toms-backhoe-7.webp",
        description:
          '#4 rebar was used for stirrups in the footing area spaced 24" on center',
      },
      {
        image: "/images/projects/toms-backhoe-8.webp",
        description:
          "Concrete was poured using a site mixer because of the remote location. The deep footing was filled first, then the slab",
      },
      {
        image: "/images/projects/toms-backhoe-9.webp",
        description:
          "#4 dowels were wet set into the concrete to tie into the Logix ICF walls",
      },
      {
        image: "/images/projects/toms-backhoe-10.webp",
        description: "Fast-Tube™ setup and braced, ready for concrete",
      },
      {
        image: "/images/projects/toms-backhoe-11.webp",
        description:
          "Fast-Tube is very fast to strip, simply pull on the alignment tab",
      },
    ],
  },
  econDeepCove: {
    0: [
      {
        image: "/images/projects/top-of-site.webp",
        description:
          "View from the top of site to the waterfront, with 2 excavators operating in tandem",
      },
      {
        image: "/images/projects/3d-model-of-site.webp",
        description:
          "This 3-D model of the site was produced from surveyor and Econ reference points",
      },
      {
        image: "/images/projects/3d-model-with-icf.webp",
        description:
          "The 3-D model was used to estimate the quantity of Amvic® blocks",
      },
      {
        image: "/images/projects/backhoe-at-waterfront.webp",
        description:
          "The lower backhoe is excavating for the first level of footings",
      },
      {
        image: "/images/projects/backhoe-double.webp",
        description:
          "Two backhoes operating in tandem were required to remove the overburden from the steep site",
      },
      {
        image: "/images/projects/backhoe.webp",
        description:
          "This backhoe is moving the overburden from the lower levels to the backhoe above",
      },
      {
        image: "/images/projects/backhoe-dutson.webp",
        description:
          "Mike Dutson, principal, Econ Group, stands on the construction access roadway located midway on the site",
      },
      {
        image: "/images/projects/staircase.webp",
        description:
          "The only way to move on the site was by using the site built staircase (looking to the top of site)",
      },
      {
        image: "/images/projects/east-elevation.webp",
        description:
          "The Architect's east elevation, the red line shows the rock profile",
      },
      {
        image: "/images/projects/west-elevation.webp",
        description:
          "The Architect's west elevation, the red line shows the rock profile",
      },
      {
        image: "/images/projects/north-elevation.webp",
        description: "The Architect's north elevation overlooking the ocean",
      },
    ],
    1: [
      {
        image: "/images/projects/overview-looking-up.webp",
        description:
          "View from the waterfront, the house in the top left corner is the top of the lot 177' above",
      },
      {
        image: "/images/projects/overview-looking-up-2.webp",
        description:
          "View from the north west, the lower level of the house will have direct ocean access",
      },
      {
        image: "/images/projects/overview-second-level.webp",
        description:
          "Looking south at the top of the first level foundation walls",
      },
      {
        image: "/images/projects/overview-top-of-foundation.webp",
        description:
          "These walls are 17' in height, note the extensive steel in the walls",
      },
      {
        image: "/images/projects/overview-top-of-foundation-2.webp",
        description:
          "View from the third level looking down at the second level",
      },
      {
        image: "/images/projects/top-end-of-foundation.webp",
        description:
          "View at the top of the foundation (south end), note the rugged rock conditions",
      },
      {
        image: "/images/projects/zont-view.webp",
        description:
          "Zont™ brackets were perfect for truing up the walls both horizontally and vertically",
      },
      {
        image: "/images/projects/zont-view-2.webp",
        description:
          "The slot in the vertical face of the Zont™ allows for vertical compression of the ICF",
      },
      {
        image: "/images/projects/zont-view-3.webp",
        description:
          "Scaffolding was made with site lumber which will be used for framing in the house",
      },
      {
        image: "/images/projects/end-of-wallbuck.webp",
        description:
          "End-of-wall end bucks are easily braced. This is not possible with ICF bracing",
      },
      {
        image: "/images/projects/end-of-wallbuck-2.webp",
        description:
          "There are 10 end-of-wall bucks in the foundation, all braced between the walers",
      },
    ],
    2: [
      {
        image: "/images/projects/concrete-to-line-pump.webp",
        description:
          "Front end loader delivers concrete from the ready mix truck above to the line pump at mid-station",
      },
      {
        image: "/images/projects/concrete-on-skidster.webp",
        description:
          "The loader moves concrete from the ready mix truck above to the line pump below",
      },
      {
        image: "/images/projects/fastfoot-1.webp",
        description:
          "Footings over the jagged granite were formed with Fastfoot®",
      },
      {
        image: "/images/projects/fastfoot-2.webp",
        description:
          "On the steep drop-off to the right, the ICF blocks were scribed to the rock",
      },
      {
        image: "/images/projects/steel-1.webp",
        description:
          "Vancouver is a high seismic area, rebar requirements were significant",
      },
      {
        image: "/images/projects/steel-2.webp",
        description:
          "The contractor has placed a Zont/waler assembly on the top of this wall to align it precisely",
      },
      {
        image: "/images/projects/ready-for-concrete.webp",
        description: "Ready for concrete",
      },
      {
        image: "/images/projects/line-pump-downstairs.webp",
        description:
          "The line pump travels down the staircase to the top of foundation",
      },
      {
        image: "/images/projects/filling-forms-2.webp",
        description:
          "Filling the forms, the ICF block and bracing performed perfectly",
      },
      {
        image: "/images/projects/filling-forms.webp",
        description: "Filling the forms was uneventful",
      },
      {
        image: "/images/projects/icf-shrinkage.webp",
        description:
          "Zonts™ allow for vertical compression due to heat buildup during the concrete pour",
      },
    ],
  },
  zbTomsBackhoe: {
    0: [
      {
        image: "/images/projects/sunset.webp",
        description: "Setting up Zont™ strongbacks in the evening light",
      },
      {
        image: "/images/projects/zont-setup.webp",
        description: "Gabe's crew begins to install the Zont™ bracing",
      },
      {
        image: "/images/projects/kickers.webp",
        description:
          "Kickers are attached to the plywood gussets on the strongbacks",
      },
      {
        image: "/images/projects/ready-for-concrete-1.webp",
        description:
          "Zuckle™ turnbuckles are attached to bottom end of the kickers, enabling perfect wall alignment",
      },
      {
        image: "/images/projects/window-buck.webp",
        description: "Horizont bracing does not interfer with window bucks",
      },
      {
        image: "/images/projects/garage-area.webp",
        description: "Zont™ bracing in garage area",
      },
      {
        image: "/images/projects/ready-for-concrete-2.webp",
        description:
          "Zuckle™ turnbuckles are attached to bottom end of the kickers, enabling perfect wall alignment",
      },
      {
        image: "/images/projects/zont-overview-outside.webp",
        description: "Wall braced with Zonts™ and Zuckles™, ready for concrete",
      },
    ],
  },
  fastfootMpManufacture: {
    2: [
      {
        image: "/images/mp-generic-foundation.webp",
        description:
          "This foundation is built with four corner components and three straight components",
      },
      {
        image: "/images/mp-corner.webp",
        description:
          "Starting with a standard corner component, and working clockwise",
      },
      {
        image: "/images/mp-custom-corner.webp",
        description:
          "Next a corner component with a corner offset is placed to the right",
      },
      {
        image: "/images/mp-corner-1.webp",
        description: "A standard corner is installed next",
      },
      {
        image: "/images/mp-standard.webp",
        description: "A 12' straight component is installed",
      },
      {
        image: "/images/mp-custom-straight.webp",
        description:
          "A trimmed straight component is installed to achieve the wall dimension",
      },
      {
        image: "/images/mp-corner-2.webp",
        description: "A standard corner is installed",
      },
      {
        image: "/images/mp-custom-straight.webp",
        description: "A trimmed straight component is installed",
      },
      {
        image: "/images/mp-corner-3.webp",
        description: "A standard corner is installed",
      },
      {
        image: "/images/mp-standard-straight.webp",
        description:
          "Two standard straight components are installed, layer is now complete",
      },
      {
        image: "/images/mp-layers.webp",
        description:
          "Then next two layers are installed, either pre-built or assembled onsite",
      },
    ],
  },
  installation: {
    3: [
      {
        image: "/images/fastfoot-commercial-installation-one2x8-1.webp",
        description: "2x8s for screed boards are cut to length",
      },
      {
        image: "/images/fastfoot-commercial-installation-four2x8s-1.webp",
        description: "Four 2x8s are laid out in position around the perimeter",
      },
      {
        image:
          "/images/fastfoot-commercial-installation-four2x8s-with-hinges-1.webp",
        description:
          "Corners are nailed or screwed together, metal strapping added for reinforcement",
      },
      {
        image: "/images/fastfoot-commercial-installation-hinge-detail-1.webp",
        description:
          "Strap hinges are ideal when reusing formwork. A removable rebar pin is used",
      },
      {
        image: "/images/fastfoot-commercial-installation-first-post-1.webp",
        description:
          "Use the assembled screed board as a template for the 2x4 posts",
      },
      {
        image: "/images/fastfoot-commercial-installation-all-posts-1.webp",
        description: "Posts are driven around the perimeter 4' to 6' on center",
      },
    ],
    4: [
      {
        image:
          "/images/fastfoot-commercial-installation-lifted-screed-board-2.webp",
        description:
          "A laser is used to level up the screed board to the top of the footing",
      },
      {
        image: "/images/fastfoot-commercial-installation-first-rail-2.webp",
        description:
          'The first rail is installed under the screed board if the distance exceeds 16"',
      },
      {
        image: "/images/fastfoot-commercial-installation-second-rail-2.webp",
        description:
          "The second rail is installed between the first rail and ground to prevent excessive bulging",
      },
      {
        image:
          "/images/fastfoot-commercial-installation-first-stake-assembly-2.webp",
        description:
          "Each post is braced to the ground at the top and at a midpoint",
      },
      {
        image: "/images/fastfoot-commercial-installation-allbracing-2.webp",
        description: "Lateral bracing is installed on all posts",
      },
    ],
    5: [
      {
        image:
          "/images/fastfoot-commercial-installation-install-fastfoot-3.webp",
        description:
          "Fastfoot® is installed around the perimeter of the fence using a hammer tacker",
      },
      {
        image: "/images/fastfoot-commercial-installation-12-inches-3.webp",
        description:
          'The concrete is poured in 12" lifts to minimize bulging and fabric tension',
      },
      {
        image: "/images/fastfoot-commercial-installation-24-inches-3.webp",
        description:
          "The second lift is placed in the form once the first lift has gone off",
      },
      {
        image: "/images/fastfoot-commercial-installation-36-inches-3.webp",
        description: "The third lift has now been poured",
      },
      {
        image: "/images/fastfoot-commercial-installation-42-inches-3.webp",
        description: 'The form has been filled with 42" of concrete',
      },
      {
        image: "/images/fastfoot-commercial-installation-stripping-3.webp",
        description: "Completed pad after lumber has been stripped",
      },
    ],
  },
};